{#if show}
  <FieldContainer {...container}>

    <div slot="before-area">
      <slot name="before"></slot>
    </div>

    <span slot="input-area">

      {#if container.readonly}
        <Text nm pt="sm" pb="xs" width="100%">
          {value}
        </Text> 
      {/if}

      {#if !container.readonly}
        <Select 
          bind:value={value} 
          on:focus={()=>{container.focused=true;}}
          on:blur={()=>{container.focused=false;}}
          options={field.options}
          id={id} 
          font-size="md"
          border="none"
          border-bottom="input"
          mt={container.layout==="stacked" ? "nm" : null}
          pt="sm"
          pb="sm"
          line="20px"
          bg="transparent"
          focus-bg="light"
          width={field.size === '100%' ? field.size : (field.size ? field.size+'ch' : null)}
          overflow="hidden"
        />
      {/if}

    </span>

    <div slot="limits-area"></div>

    <div slot="after-area">
      <slot name="after"></slot>
    </div>

  </FieldContainer>
{/if}

<script>
  import { onMount } from 'svelte'
  import { Text, Select } from 'svelte-stylo';
  import FieldContainer from '../container/FieldContainer.svelte'
  import { updateContainer } from '../container/helpers'
  import { copyProps, FieldContainerProps, OptionsFieldProps } from '../properties'
  import { validateIf, isEmpty } from '../validators'
  import { randid } from '../helpers'

  export let
    show = true,
    value,
    container = {...FieldContainerProps},
    field = {...OptionsFieldProps},
    validators = [isEmpty];

  let
    id = null;

  value = (value === null && field.initial !== null) ? field.initial : value;
  id = field.id || randid();

  onMount(() => {
  })

  $: if ($$props) {
    // copy simple props if the exist
    container = copyProps(container, $$props);
    field = copyProps(field, $$props);
  }

  $: if (field !== null && container !== null) {
    container = updateContainer(container, field, value);
  };

  $: if (value !== null) {
    container.errors = validateIf(value, field, validators)
    container = updateContainer(container, field, value);
  }

</script>
